import Form from "../Form";
import "./style.css";

export default class RegistrationForm {
  static selector = ".registration-form";

  constructor(block) {
    this.block = block;

    this.formElement = this.block.querySelector(".registration-form__form");

    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: false,
    });

    this.passwordStrengthBadge = this.block.querySelector(
      ".form__password-strength"
    );

    this.passwordWarning = this.block.querySelector(".form__warning");

    this.strongPassword = new RegExp(
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{12,})"
    );
    this.mediumPassword = new RegExp(
      "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{7,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{12,}))"
    );
    this.weakPassword = new RegExp(
      "((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{5,}))"
    );
  }

  handleSubmitFailed = () => {};

  handleSubmitSucceeded = () => {
    window.scrollTo({ top: 0 });
    window.App.modals.registrationSuccessModal.open();
  };

  handleRadioChange = () => {
    this.membershipRadio.forEach((radio) => {
      if (radio.value == "Student" && radio.checked) {
        this.studentId.classList.remove("form__group--disabled");
        this.fileField = this.studentId.querySelector(".file-upload input");
        this.fileField.removeAttribute("disabled");
        this.fileField.required = true;
      } else if (radio.value == "Regular" && radio.checked) {
        this.studentId.classList.add("form__group--disabled");
        this.fileField = this.studentId.querySelector(".file-upload input");
        this.fileField.disabled = true;
        this.fileField.required = false;
      }
    });
  };

  checkPasswordStrength = (password) => {
    this.passwordWarning.classList.add("form__warning--hidden");
    this.passwordStrengthBadge.classList.add("form__password-strength--show");

    if (this.passwordValue.length == 0) {
      this.passwordWarning.classList.remove("form__warning--hidden");
      this.passwordStrengthBadge.classList.remove(
        "form__password-strength--show"
      );
    }

    let backgroundColor;
    let borderColor;

    if (this.strongPassword.test(password)) {
      backgroundColor = "#85c276";
      borderColor = "#c2e0ba";
      this.passwordStrengthBadge.innerText = window.saee.copy["Strong"];
    } else if (this.mediumPassword.test(password)) {
      backgroundColor = "#fee29d";
      borderColor = "#fec645";
      this.passwordStrengthBadge.innerText = window.saee.copy["Medium"];
    } else if (this.weakPassword.test(password)) {
      backgroundColor = "#fac5ab";
      borderColor = "#f58b59";
      this.passwordStrengthBadge.innerText = window.saee.copy["Weak"];
    } else {
      backgroundColor = "#f0adae";
      borderColor = "#e15c5e";
      this.passwordStrengthBadge.innerText = window.saee.copy["Very weak"];
    }

    this.passwordStrengthBadge.style.background = backgroundColor;
    this.passwordStrengthBadge.style.borderColor = borderColor;
  };

  handlePasswordChange = (e) => {
    this.passwordValue = e.target.value;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(
      () => this.checkPasswordStrength(this.passwordValue),
      500
    );
  };

  onReady() {
    this.membershipRadio = this.block
      .querySelector(".radio-buttons--membership")
      .querySelectorAll(".radio-buttons__option-input");

    this.membershipRadio.forEach((radio) =>
      radio.addEventListener("change", this.handleRadioChange)
    );

    this.studentId = this.block.querySelector(".form__group--student-id");

    this.passwordField = this.block.querySelector(
      "input#registration-password"
    );

    this.passwordField.addEventListener("input", this.handlePasswordChange);
  }

  onResize() {}

  onDestroy() {
    this.membershipRadio.forEach((radio) =>
      radio.removeEventListener("change", this.handleRadioChange)
    );

    this.passwordField.removeEventListener("input", this.handlePasswordChange);
  }
}
